import React from 'react';
import SMSKeywordsSlideoutBannerNormalSrc from './SMSKeywordsSlideoutBanner_normal.png';
import SMSKeywordsSlideoutBannerWhiteSrc from './SMSKeywordsSlideoutBanner_white.png';

export const SMSKeywordsSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={SMSKeywordsSlideoutBannerWhiteSrc} />
  ) : (
    <img src={SMSKeywordsSlideoutBannerNormalSrc} />
  );
};
